// src/components/dashboard/FreshnessCard.tsx
import React from 'react';

interface FreshnessCardProps {
  published: boolean;
  daysSinceUpdate: number | null;
}

export const FreshnessCard: React.FC<FreshnessCardProps> = ({ published, daysSinceUpdate }) => {
  if (!published) {
    return (
      <div className="rounded-xl border border-brand-border p-6">
        <h2 className="text-sm font-medium text-brand-black mb-1">Freshness</h2>
        <p className="text-sm text-brand-gray">Not yet published.</p>
      </div>
    );
  }

  const label =
    daysSinceUpdate === 0
      ? 'Updated today'
      : `Last updated ${daysSinceUpdate} day${daysSinceUpdate === 1 ? '' : 's'} ago`;

  return (
    <div className="rounded-xl border border-brand-border p-6">
      <h2 className="text-sm font-medium text-brand-black mb-1">Freshness</h2>
      <p className="text-sm text-brand-charcoal">{label}</p>
    </div>
  );
};